import * as THREE from 'three';
import React, { Component } from 'react';
import ShowFullBuilding from "../BuildingCanvas/ShowFullBuilding";
import { connect } from "react-redux";
import * as cuComponent from '../../redux/reducers/building_component/componentReducer.js';
import {ChangeBackgroundAccordingtoCon,ShowMeasure,commonConfirmationAlert,CallPublicAPI,handleCloseforDoorWindows,ShowHideTranslusant,handleShowfeedback, clearComponents,fullViewbuild, handleShowPhotoModal, getSelectedTab, handleShowShareModal, updateDoorWindowPosition, removeComponent} from "../../action/index.js";
import {captureBlobImages,handleShowExtras} from "../../action/extra_options/orderExtras.action.js";
import { Modal, Button, OverlayTrigger,Tooltip } from "react-bootstrap";
// import centeraligicon from '../../../assets/images/alignment.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import { Checkbox } from '@rmwc/checkbox';
import TwoDMapModal from '../ControlPanel/Common/TwoDBuildingMap/TwoDMapModal.js';
import TWEEN from '@tweenjs/tween.js'
import AnimButton from '../Button/AnimButton';
import { controls } from '../../redux/reducers/common/eventReducer.js';
import ViewInYourSpaceModal from '../Modals/ViewInYourSpaceModal.js';
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);

    }}
  >
    {children}
    &#x25bc;
  </a>
));
class BuildingController extends Component {


  constructor(props) {
    super(props);
    this.state = {
      isAutoRotate: false,
      isNavInOut: false,
      tabName: "",
      // isfullviewbuilding: (this.props.const_var.ishideLeftNevigationBar != undefined && this.props.const_var.ishideLeftNevigationBar) ? true : false,
      isShowFeedback: false,
      isExtraHoverd: false,
      showViewInYourSpaceModal: false,
    }

  }
   setAlignCenter = () => {
    if (this.props.const_var.newDoorsArray.length > 0) {
      const activeWall = this.props.params.activeWall;

      let sortByPosX = (arr) => (arr.sort((a, b) => (a.positionX - b.positionX)));
      let filterRecord = sortByPosX(this.props.const_var.newDoorsArray.filter(data => data.userData.wallName === activeWall))

      if (filterRecord.length > 0) {
        let resultPosXArr = [];
        let resultPosYArr = [];
        let objIndex = 0;
        let preDoorWidth;

        let distanceBtw = 1;
        let wallWidth, wallHeight = 0;
        let initOffsetPosX = 0;

        if (activeWall === 'c_b_f_w' || activeWall === 'c_b_b_w' || activeWall === 'c_b_f_s_w' || activeWall === 'c_b_b_s_w') {
          wallWidth = this.props.params.p_w;
          wallHeight = this.props.params.p_h;
          initOffsetPosX = 0;
          if(this.props.params.singleSlope) wallHeight -= Number(this.props.params.p_r_p)/12 * this.props.params.p_w;        
        } if(activeWall === 'c_b_r_s_w'){
          wallWidth = Number(this.props.params.p_u_t);
          wallHeight = this.props.params.p_h;
          initOffsetPosX = (((this.props.params.p_d - wallWidth) / 2) - this.props.params.endStoragePositionZ)
        } else if( activeWall === 'c_b_l_s_w'){
          wallWidth = Number(this.props.params.p_u_t);
          wallHeight = this.props.params.p_h;
          initOffsetPosX = (((-this.props.params.p_d + wallWidth ) / 2) + this.props.params.endStoragePositionZ)
        } else if (activeWall === 'c_b_r_s_f_w') {
          wallWidth = Number(this.props.params.cB_addStorage_right);
          wallHeight = this.props.params.p_h;
          initOffsetPosX = (this.props.params.p_w / 2) - (wallWidth / 2)
        } else if (activeWall === 'c_b_l_s_f_w') {
          wallWidth = Number(this.props.params.cB_addStorage_left);
          wallHeight = this.props.params.p_h;
          initOffsetPosX = (-this.props.params.p_w / 2) + (wallWidth / 2)
        } else if (activeWall === 'c_b_r_s_b_w') {
          wallWidth = Number(this.props.params.cB_addStorage_right);
          wallHeight = this.props.params.p_h;
          initOffsetPosX = -((this.props.params.p_w / 2) - (wallWidth / 2))
        } else if (activeWall === 'c_b_l_s_b_w') {
          wallWidth = Number(this.props.params.cB_addStorage_left);
          wallHeight = this.props.params.p_h;
          initOffsetPosX = -((-this.props.params.p_w / 2) + (wallWidth / 2))
          
        } else if (activeWall === 'c_b_l_w' || activeWall === 'c_b_r_w' || activeWall === 'c_b_l_s_r_w' || activeWall === 'c_b_r_s_l_w') {
          wallWidth = this.props.params.p_d;
          wallHeight = this.props.params.p_h;
          initOffsetPosX = 0
        } else if (activeWall === 'F_L_F_W') {
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentFront) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentFront) === 2) offsetLeanAlignment = -this.props.params.p_w / 2 + this.props.params.leanF_p_d / 2;
          else if (Number(this.props.params.leantoAlignmentFront) === 3) offsetLeanAlignment = this.props.params.p_w / 2 - this.props.params.leanF_p_d / 2;
          else offsetLeanAlignment = this.props.params.leanF_p_pos;

          let offsetPosX = 0
          let addWidth = 0
          if (this.props.params.add_left_front_lean_porch && !this.props.params.add_right_front_lean_porch) {
            offsetPosX = this.props.params.lean_p_w / 2;
            addWidth = this.props.params.lean_p_w;
          } else if (!this.props.params.add_left_front_lean_porch && this.props.params.add_right_front_lean_porch) {
            offsetPosX = -this.props.params.leanR_p_w / 2;
            addWidth = this.props.params.leanR_p_w;
          } else if (this.props.params.add_left_front_lean_porch && this.props.params.add_right_front_lean_porch) {
            offsetPosX = this.props.params.lean_p_w / 2 - this.props.params.leanR_p_w / 2;
            addWidth = this.props.params.leanR_p_w + this.props.params.lean_p_w;
          } else {
            offsetPosX = 0;
            addWidth = 0;
          }
          wallWidth = this.props.params.leanF_p_d + addWidth;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = 0 + offsetLeanAlignment - offsetPosX;
        } else if(activeWall === 'F_L_F_S_W'){
          wallWidth = this.props.params.leanF_p_w;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = -this.props.params.leanF_p_d/2 + this.props.params.add_storage_front/ 2 + this.props.params.frontLeanStoragePosition;
        }else if(activeWall === 'B_L_F_S_W'){
          wallWidth = this.props.params.leanF_p_w;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = this.props.params.leanB_p_d/2 - this.props.params.add_storage_back/ 2 - this.props.params.backLeanStoragePosition;
        } else if (activeWall === 'F_L_R_W' || activeWall === 'F_L_R_S_W') {
          wallWidth = this.props.params.leanF_p_w;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = -(this.props.params.p_d / 2 + wallWidth / 2);
        } else if (activeWall === 'F_L_L_W') {
          wallWidth = this.props.params.leanF_p_w;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = this.props.params.p_d / 2 + wallWidth / 2;
        } else if (activeWall === 'B_L_S_W') {
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentBack) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentBack) === 2) offsetLeanAlignment = -(this.props.params.p_w / 2 - this.props.params.leanB_p_d / 2);
          else if ((Number(this.props.params.leantoAlignmentBack) === 2)) offsetLeanAlignment = (this.props.params.p_w / 2 - this.props.params.leanB_p_d / 2);
          else offsetLeanAlignment = -this.props.params.leanB_p_pos;

          let offsetPosX = 0
          let addWidth = 0
          if (this.props.params.add_left_back_lean_porch && !this.props.params.add_right_back_lean_porch) {
            offsetPosX = -this.props.params.lean_p_w / 2;
            addWidth = this.props.params.lean_p_w;
          } else if (!this.props.params.add_left_back_lean_porch && this.props.params.add_right_back_lean_porch) {
            offsetPosX = this.props.params.leanR_p_w / 2;
            addWidth = this.props.params.leanR_p_w;
          } else if (this.props.params.add_left_back_lean_porch && this.props.params.add_right_back_lean_porch) {
            offsetPosX = this.props.params.leanR_p_w / 2 - this.props.params.lean_p_w / 2;
            addWidth = this.props.params.leanR_p_w + this.props.params.lean_p_w;
          } else {
            offsetPosX = 0;
            addWidth = 0;
          }
          wallWidth = this.props.params.leanB_p_d + addWidth;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = 0 + offsetLeanAlignment - offsetPosX;
        } else if (activeWall === 'B_L_B_W') {
          wallWidth = this.props.params.leanB_p_w;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = -(this.props.params.p_d / 2 + wallWidth / 2);
        } else if (activeWall === 'B_L_F_W' || activeWall === 'B_L_L_S_W') {
          wallWidth = this.props.params.leanB_p_w;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = this.props.params.p_d / 2 + wallWidth / 2;
        } else if (activeWall === 'L_L_L_W') {
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentLeft) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentLeft) === 2) offsetLeanAlignment = this.props.params.p_d / 2 - this.props.params.lean_p_d / 2;
          else if(Number(this.props.params.leantoAlignmentLeft) === 3) offsetLeanAlignment = -this.props.params.p_d / 2 + this.props.params.lean_p_d / 2;
          else offsetLeanAlignment = this.props.params.lean_p_pos;

          let offsetPosX = 0
          let addWidth = 0
          if (this.props.params.add_left_front_lean_porch && !this.props.params.add_left_back_lean_porch) {
            offsetPosX = -this.props.params.leanF_p_w / 2;
            addWidth = this.props.params.leanF_p_w;
          } else if (!this.props.params.add_left_front_lean_porch && this.props.params.add_left_back_lean_porch) {
            offsetPosX = this.props.params.leanB_p_w / 2;
            addWidth = this.props.params.leanB_p_w;
          } else if (this.props.params.add_left_front_lean_porch && this.props.params.add_left_back_lean_porch) {
            offsetPosX = this.props.params.leanF_p_w / 2 - this.props.params.leanB_p_w / 2;
            addWidth = this.props.params.leanF_p_w + this.props.params.leanB_p_w;
          } else {
            offsetPosX = 0;
            addWidth = 0;
          }
          wallWidth = this.props.params.lean_p_d + addWidth;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = 0 + offsetLeanAlignment - offsetPosX;
        } else if (activeWall === 'L_L_F_W' || activeWall === 'L_L_F_S_W') {
          wallWidth = this.props.params.lean_p_w;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = -(this.props.params.p_w / 2 + wallWidth / 2);
        } else if (activeWall === 'L_L_B_W') {
          wallWidth = this.props.params.lean_p_w;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = this.props.params.p_w / 2 + wallWidth / 2;
        } else if (activeWall === 'L_L_R_S_W') {
          wallWidth = this.props.params.add_storage;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = (this.props.params.p_d / 2 - this.props.params.add_storage / 2);
        } else if (activeWall === 'R_L_R_S_W'){
          wallWidth = this.props.params.add_storage_right;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = this.props.params.leanR_p_d / 2 - this.props.params.add_storage_right / 2 - this.props.params.rightLeanStoragePosition;
        } else if (activeWall === 'L_L_L_S_W'){
          wallWidth = this.props.params.add_storage;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = -this.props.params.lean_p_d / 2 + this.props.params.add_storage / 2 + this.props.params.leftLeanStoragePosition;
        } else if (activeWall === 'G_R_L_B_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentRight) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentRight) === 2) offsetLeanAlignment = this.props.params.p_d / 2 - this.props.params.leanR_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentRight) === 3) offsetLeanAlignment = -this.props.params.p_d / 2 + this.props.params.leanR_p_w / 2;
          else offsetLeanAlignment = this.props.params.leanR_p_pos;

          wallWidth = this.props.params.leanR_p_w;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_R_L_B_S_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentRight) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentRight) === 2) offsetLeanAlignment = this.props.params.p_d / 2 - this.props.params.leanR_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentRight) === 3) offsetLeanAlignment = -this.props.params.p_d / 2 + this.props.params.leanR_p_w / 2;
          else offsetLeanAlignment = this.props.params.leanR_p_pos;

          wallWidth = this.props.params.leanR_p_w;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_R_L_F_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentRight) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentRight) === 2) offsetLeanAlignment = -this.props.params.p_d / 2 + this.props.params.leanR_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentRight) === 3) offsetLeanAlignment = this.props.params.p_d / 2 - this.props.params.leanR_p_w / 2;
          else offsetLeanAlignment = -this.props.params.leanR_p_pos;

          wallWidth = this.props.params.leanR_p_w;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_R_L_F_S_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentRight) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentRight) === 2) offsetLeanAlignment = -this.props.params.p_d / 2 + this.props.params.leanR_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentRight) === 3) offsetLeanAlignment = this.props.params.p_d / 2 - this.props.params.leanR_p_w / 2;
          else offsetLeanAlignment = this.props.params.leanR_p_pos;

          wallWidth = this.props.params.leanR_p_w;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_R_L_L_W'){     
          wallWidth = this.props.params.leanR_p_d;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = (this.props.params.p_w / 2 + wallWidth / 2);
        } else if (activeWall === 'G_R_L_L_S_W'){     
          wallWidth = this.props.params.add_storage_right;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = this.props.params.p_w / 2 + wallWidth / 2 + this.props.params.rightLeanStoragePosition;
        } else if (activeWall === 'G_R_L_R_W'){     
          wallWidth = this.props.params.leanR_p_d;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = -(this.props.params.p_w / 2 + wallWidth / 2);
        } else if (activeWall === 'G_R_L_R_S_W'){     
          wallWidth = this.props.params.add_storage_right;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = -(this.props.params.p_w / 2 + wallWidth / 2 + this.props.params.rightLeanStoragePosition);
        } else if (activeWall === 'G_L_L_B_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentLeft) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentLeft) === 2) offsetLeanAlignment = -this.props.params.p_d / 2 + this.props.params.lean_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentLeft) === 3) offsetLeanAlignment = this.props.params.p_d / 2 - this.props.params.lean_p_w / 2;
          else offsetLeanAlignment = -this.props.params.lean_p_pos;

          wallWidth = this.props.params.lean_p_w;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_L_L_B_S_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentLeft) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentLeft) === 2) offsetLeanAlignment = -this.props.params.p_d / 2 + this.props.params.lean_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentLeft) === 3) offsetLeanAlignment = this.props.params.p_d / 2 - this.props.params.lean_p_w / 2;
          else offsetLeanAlignment = -this.props.params.lean_p_pos;

          wallWidth = this.props.params.lean_p_w;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_L_L_L_W'){     
          wallWidth = this.props.params.lean_p_d;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = (this.props.params.p_w / 2 + wallWidth / 2);
        } else if (activeWall === 'G_L_L_L_S_W'){     
          wallWidth = this.props.params.add_storage;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = (this.props.params.p_w / 2 + wallWidth / 2 + this.props.params.leftLeanStoragePosition)
        } else if (activeWall === 'G_L_L_R_W'){     
          wallWidth = this.props.params.lean_p_d;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = -(this.props.params.p_w / 2 + wallWidth / 2);
        } else if (activeWall === 'G_L_L_R_S_W'){     
          wallWidth = this.props.params.add_storage;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = -(this.props.params.p_w / 2 + wallWidth / 2 + this.props.params.leftLeanStoragePosition)
        } else if (activeWall === 'G_L_L_F_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentLeft) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentLeft) === 2) offsetLeanAlignment = this.props.params.p_d / 2 - this.props.params.lean_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentLeft) === 3) offsetLeanAlignment = -this.props.params.p_d / 2 + this.props.params.lean_p_w / 2;
          else offsetLeanAlignment = this.props.params.lean_p_pos;

          wallWidth = this.props.params.lean_p_w;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_L_L_F_S_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentLeft) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentLeft) === 2) offsetLeanAlignment = this.props.params.p_d / 2 - this.props.params.lean_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentLeft) === 3) offsetLeanAlignment = -this.props.params.p_d / 2 + this.props.params.lean_p_w / 2;
          else offsetLeanAlignment = this.props.params.lean_p_pos;

          wallWidth = this.props.params.lean_p_w;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'R_L_R_W') {
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentRight) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentRight) === 2) offsetLeanAlignment = -this.props.params.p_d / 2 + this.props.params.leanR_p_d / 2;
          else if (Number(this.props.params.leantoAlignmentRight) === 3) offsetLeanAlignment = this.props.params.p_d / 2 - this.props.params.leanR_p_d / 2;
          else offsetLeanAlignment = -this.props.params.leanR_p_pos;

          let offsetPosX = 0
          let addWidth = 0
          if (this.props.params.add_right_front_lean_porch && !this.props.params.add_right_back_lean_porch) {
            offsetPosX = this.props.params.leanF_p_w / 2;
            addWidth = this.props.params.leanF_p_w;
          } else if (!this.props.params.add_right_front_lean_porch && this.props.params.add_right_back_lean_porch) {
            offsetPosX = -this.props.params.leanB_p_w / 2;
            addWidth = this.props.params.leanB_p_w;
          } else if (this.props.params.add_right_front_lean_porch && this.props.params.add_right_back_lean_porch) {
            offsetPosX = this.props.params.leanF_p_w / 2 - this.props.params.leanB_p_w / 2;
            addWidth = this.props.params.leanF_p_w + this.props.params.leanB_p_w;
          } else {
            offsetPosX = 0;
            addWidth = 0;
          }
          wallWidth = this.props.params.leanR_p_d + addWidth;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = 0 + offsetLeanAlignment - offsetPosX;
        } else if (activeWall === 'G_F_L_B_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentFront) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentFront) === 2) offsetLeanAlignment = this.props.params.p_w / 2 - this.props.params.leanF_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentFront) === 3) offsetLeanAlignment = -this.props.params.p_w / 2 + this.props.params.leanF_p_w / 2;
          else offsetLeanAlignment = -this.props.params.leanF_p_pos;

          wallWidth = this.props.params.leanF_p_w;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_F_L_B_S_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentFront) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentFront) === 2) offsetLeanAlignment = this.props.params.p_w / 2 - this.props.params.leanF_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentFront) === 3) offsetLeanAlignment = -this.props.params.p_w / 2 + this.props.params.leanF_p_w / 2;
          else offsetLeanAlignment = -this.props.params.leanF_p_pos;

          wallWidth = this.props.params.leanF_p_w;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_F_L_L_W'){     
          wallWidth = this.props.params.leanF_p_d;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = (this.props.params.p_d / 2 + wallWidth / 2);
        } else if (activeWall === 'G_F_L_L_S_W'){     
          wallWidth = this.props.params.add_storage_front;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = (this.props.params.p_d / 2 + wallWidth / 2 + this.props.params.frontLeanStoragePosition)
        } else if (activeWall === 'G_F_L_R_W'){     
          wallWidth = this.props.params.leanF_p_d;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = -(this.props.params.p_d / 2 + wallWidth / 2);
        } else if (activeWall === 'G_F_L_R_S_W'){     
          wallWidth = this.props.params.add_storage_front;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = -(this.props.params.p_d / 2 + wallWidth / 2 + this.props.params.frontLeanStoragePosition)
        } else if (activeWall === 'G_F_L_F_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentFront) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentFront) === 2) offsetLeanAlignment = -this.props.params.p_w / 2 + this.props.params.leanF_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentFront) === 3) offsetLeanAlignment = this.props.params.p_w / 2 - this.props.params.leanF_p_w / 2;
          else offsetLeanAlignment = this.props.params.leanF_p_pos;

          wallWidth = this.props.params.leanF_p_w;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_F_L_F_S_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentFront) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentFront) === 2) offsetLeanAlignment = -this.props.params.p_w / 2 + this.props.params.leanF_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentFront) === 3) offsetLeanAlignment = this.props.params.p_w / 2 - this.props.params.leanF_p_w / 2;
          else offsetLeanAlignment = this.props.params.leanF_p_pos;

          wallWidth = this.props.params.leanF_p_w;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_B_L_B_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentBack) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentBack) === 2) offsetLeanAlignment = this.props.params.p_w / 2 - this.props.params.leanB_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentBack) === 3) offsetLeanAlignment = -this.props.params.p_w / 2 + this.props.params.leanB_p_w / 2;
          else offsetLeanAlignment = -this.props.params.leanB_p_pos;

          wallWidth = this.props.params.leanB_p_w;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_B_L_B_S_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentBack) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentBack) === 2) offsetLeanAlignment = this.props.params.p_w / 2 - this.props.params.leanB_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentBack) === 3) offsetLeanAlignment = -this.props.params.p_w / 2 + this.props.params.leanB_p_w / 2;
          else offsetLeanAlignment = -this.props.params.leanB_p_pos;

          wallWidth = this.props.params.leanB_p_w;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_B_L_L_W'){     
          wallWidth = this.props.params.leanB_p_d;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = (this.props.params.p_d / 2 + wallWidth / 2);
        } else if (activeWall === 'G_B_L_L_S_W'){     
          wallWidth = this.props.params.add_storage_back;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = (this.props.params.p_d / 2 + wallWidth / 2 + this.props.params.backLeanStoragePosition)
        } else if (activeWall === 'G_B_L_R_W'){     
          wallWidth = this.props.params.leanB_p_d;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = -(this.props.params.p_d / 2 + wallWidth / 2);
        } else if (activeWall === 'G_B_L_R_S_W'){     
          wallWidth = this.props.params.add_storage_back;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = -(this.props.params.p_d / 2 + wallWidth / 2 + this.props.params.backLeanStoragePosition)
        } else if (activeWall === 'G_B_L_F_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentBack) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentBack) === 2) offsetLeanAlignment = -this.props.params.p_w / 2 + this.props.params.leanB_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentBack) === 3) offsetLeanAlignment = this.props.params.p_w / 2 - this.props.params.leanB_p_w / 2;
          else offsetLeanAlignment = this.props.params.leanB_p_pos;

          wallWidth = this.props.params.leanB_p_w;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'G_B_L_F_S_W'){
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentBack) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentBack) === 2) offsetLeanAlignment = -this.props.params.p_w / 2 + this.props.params.leanB_p_w / 2;
          else if (Number(this.props.params.leantoAlignmentBack) === 3) offsetLeanAlignment = this.props.params.p_w / 2 - this.props.params.leanB_p_w / 2;
          else offsetLeanAlignment = this.props.params.leanB_p_pos;

          wallWidth = this.props.params.leanB_p_w;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = offsetLeanAlignment;
        } else if (activeWall === 'R_L_F_W' || activeWall === 'R_L_F_S_W') {
          wallWidth = this.props.params.leanR_p_w;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = this.props.params.p_w / 2 + wallWidth / 2;
        } else if (activeWall === 'R_L_B_W') {
          wallWidth = this.props.params.leanR_p_w;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = -(this.props.params.p_w / 2 + wallWidth / 2);
        } else if (activeWall === 'R_L_L_S_W') {
          wallWidth = this.props.params.add_storage_right;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = -(this.props.params.p_d / 2 - this.props.params.add_storage_right / 2);
        }

        distanceBtw = (wallWidth - filterRecord.reduce((pre, nxt) => { return { width: pre.width + nxt.width } })["width"]) / (filterRecord.length + 1);

        filterRecord.forEach((comp) => {
          if(comp.height >= wallHeight) {
            distanceBtw = 0;
          }
        })
        
        for (var i = 0; i <= filterRecord.length - 1; i++) {
          let resultPosX = 0;
          let resultPosY = 0;
          let objSizeArr = typeof filterRecord[i].size == 'object' ? filterRecord[i].size.name.split("x"): filterRecord[i].size.split("x");
          let doorWidth = (filterRecord[i].userData.compType === "garage_door" || filterRecord[i].userData.compType === "garage_door_frameout") ? parseInt(objSizeArr[0]) : parseInt(objSizeArr[0]) / 12;
          let doorHeight = (filterRecord[i].userData.compType === "garage_door" || filterRecord[i].userData.compType === "garage_door_frameout") ? parseInt(objSizeArr[1]) : parseInt(objSizeArr[1]) / 12;

          if (distanceBtw >= 1) {  
            // find position - X
            if (objIndex === 0) resultPosX = initOffsetPosX - wallWidth / 2 + distanceBtw + doorWidth / 2;
            else resultPosX = Number(resultPosXArr[objIndex - 1]) + preDoorWidth / 2 + distanceBtw + doorWidth / 2;

            // find position - Y
            if ((resultPosX < filterRecord[i].minLimitX || resultPosX > filterRecord[i].maxLimitX)) {
              if(filterRecord[i].userData.compType !== "window" || filterRecord[i].userData.compType !== "window_frameout"){
                let roofPitch;
                let width;
                let height;
                let positionX;

                if(this.props.const_var.focusedSection === 'center'){
                  roofPitch = this.props.params.p_r_p;
                  width = this.props.params.p_w / 2;
                  height = this.props.params.p_h;
                } else if(this.props.const_var.focusedSection === 'frontlean') {
                  roofPitch = this.props.params.b_l_t_r_pF;   
                  width = this.props.params.leanF_p_w + this.props.params.p_d / 2;
                  height = this.props.params.leanF_p_h;    
                } else if(this.props.const_var.focusedSection === 'backlean') {  
                  roofPitch = this.props.params.b_l_t_r_pB;     
                  width = this.props.params.leanB_p_w + this.props.params.p_d / 2;
                  height = this.props.params.leanB_p_h;     
                } else if(this.props.const_var.focusedSection === 'leftlean') {  
                  roofPitch = this.props.params.b_l_t_r_p;    
                  width = this.props.params.lean_p_w + this.props.params.p_w / 2;
                  height = this.props.params.lean_p_h;  
                } else if(this.props.const_var.focusedSection === 'rightlean') {  
                  roofPitch = this.props.params.b_l_t_r_pR;    
                  width = this.props.params.leanR_p_w + this.props.params.p_w / 2;
                  height = this.props.params.leanR_p_h;   
                } 

                if(this.props.params.activeWall === 'c_b_f_w'){
                  positionX = -resultPosX;
                } else if(this.props.params.activeWall === 'c_b_b_w'){
                  positionX = resultPosX;
                }
                
                const trimThickness = 0.2;
                // const trimHeight = 0.2;
                const trimHeight = 0;
                const trimOffsetHeight = (roofPitch  / 12) * trimThickness;
                if (this.props.params.singleSlope && this.props.const_var.focusedSection === 'center') {
                  const alpha = Math.atan(roofPitch  / 12);
                  resultPosY = height  - Math.tan(alpha) * (width + positionX) -  trimHeight - trimOffsetHeight - filterRecord[i].height / 2 - this.props.const_var.componentDistance
                } else {
                  // alert('dfd')
                  // resultPosY = height + roofPitch / 12 * (width - Math.abs(resultPosX)) -  trimHeight - trimOffsetHeight - filterRecord[i].height / 2 - this.props.const_var.componentDistance
                  resultPosY = height + roofPitch / 12 * (width - Math.abs(resultPosX)) -  trimHeight - trimOffsetHeight - filterRecord[i].height / 2 - this.props.const_var.componentDistance
                }
                if (filterRecord[i].userData.compType.includes('walkin') || filterRecord[i].userData.compType.includes('garage')) {
                  resultPosY = filterRecord[i].positionY;
                }
              } else {
                resultPosY = wallHeight - doorHeight / 2;
              }
            }
            else resultPosY = filterRecord[i].positionY;

            this.props.updateDoorWindowPosition(filterRecord[i].uniqueId, resultPosX, resultPosY);

            resultPosXArr[objIndex] = resultPosX;
            resultPosYArr[objIndex] = resultPosY;
            objIndex++;
            preDoorWidth = doorWidth;
          }
        }
      }

    }
  }
  zoomInOut = (inout) => { // in - true, out - false
    const controls = this.props.const_var.controls
    const camera = controls?.object;
    let dir = new THREE.Vector3();
    camera.getWorldDirection(dir);
    dir.negate();
    let dist = controls?.getDistance();
    const maxDistance = controls?.maxDistance;

    let changedDistance = dist;
    if (inout) {
      if (changedDistance > 10) {
        changedDistance -= 10
      } else {
        changedDistance = 0.1;
      }
    }
    else {
      if (changedDistance < maxDistance - 10) {
        changedDistance += 10;
      } else {
        changedDistance = maxDistance;
      }
    }

    new TWEEN.Tween({ val: dist })
      .to({ val: changedDistance }, 500)
      .onUpdate(val => {
        camera.position.copy(controls.target).addScaledVector(dir, val.val);
      })
      .easing(TWEEN.Easing.Quadratic.InOut)
      .yoyo(true)
      .start();

    controls.update();

    this.animation();
  }

  navInOut = () => {
    this.setState({
      insideoutside: !this.state.insideoutside
    });
    this.setState({
      isNavInOut: !this.state.isNavInOut
    })

    const controls = this.props.const_var.controls
    const camera = controls?.object;
    if (!this.state.isNavInOut) {
      // change camera distance      
      new TWEEN.Tween(this.props.const_var.camera?.position)
        .to({ x: 0, y: this.props.params.p_h / 2 - 0.02, z: 0.1 }, 1000)
        .easing(TWEEN.Easing.Quadratic.InOut)
        .yoyo(true)
        .start();

      /*
      let dir = new THREE.Vector3();
      camera.getWorldDirection(dir);
      dir.negate();
      let dist = controls.getDistance();

      new TWEEN.Tween({val: dist})
        .to({val: 0.01}, 1000)
        .onUpdate(val => {
          camera.position.copy(controls.target).addScaledVector(dir, val.val);
        })
        .easing(TWEEN.Easing.Quadratic.InOut)
        .yoyo(true)
        .start();
        */

      // change camera fov
      let camFov = camera.fov;
      new TWEEN.Tween({ val: camFov })
        .to({ val: 80 }, 1000)
        .onUpdate(val => {
          camera.fov = val.val;
          camera.updateProjectionMatrix();
        })
        .easing(TWEEN.Easing.Quadratic.InOut)
        .yoyo(true)
        .start();

      controls.update();

      this.animation();

    } else {
      new TWEEN.Tween(this.props.const_var.camera?.position)
        .to({ x: this.props.params.p_w / 2 + 10, y: this.props.params.p_h / 2, z: this.props.params.p_w / 2 + this.props.params.p_d / 2 + this.props.params.p_r_p / 2 + 10 }, 1000)
        .easing(TWEEN.Easing.Quadratic.InOut)
        .yoyo(true)
        .start();

      // change camera fov
      let camFov = camera.fov;
      new TWEEN.Tween({ val: camFov })
        .to({ val: 45 }, 1000)
        .onUpdate(val => {
          camera.fov = val.val;
          camera.updateProjectionMatrix();
        })
        .easing(TWEEN.Easing.Quadratic.InOut)
        .yoyo(true)
        .start();

      this.props.const_var.controls?.target?.set(0, this.props.params.p_h / 2, 0);
    }

    this.props.const_var.controls.update();
  }

  animation = () => {

    TWEEN.update();
    requestAnimationFrame(this.animation);
  }

  autoRotate = () => {
    this.props.const_var.isAutoRotate = !this.props.const_var.isAutoRotate;

    if (this.props.const_var.isAutoRotate == true) {
      this.setState({ isAutoRotate: true, })
      this.props.const_var.controls.autoRotateSpeed = 6;
      this.props.const_var.controls.autoRotate = true;
      this.props.const_var.controls.target.set(0, this.props.params.p_h / 2, 0);
    } else {
      this.props.const_var.controls.autoRotate = false;
      this.setState({ isAutoRotate: false, })
    }
    //const_var.controls.update();   
  }

  CalltoAction = () => {
    const removea = document.querySelector('div');
    removea.classList.remove("active-fullview");
    this.props.CallPublicAPI();

  }

  // fullViewbuild = () => {
  //   if (this.props.const_var.isShowEditConfigurationButton == false && this.props.const_var.crmSetting.is_quote_Edit == true) {
  //     return;
  //   }
  //   const removea = document.querySelector('body');

  //   this.setState({
  //     isfullviewbuilding: !this.state.isfullviewbuilding
  //   });

  //   if (!this.state.isfullviewbuilding) {
  //     removea.classList.add("active-fullview");

  //   }
  //   else {
  //     removea.classList.remove("active-fullview");
  //   }
  //   cuComponent.onResize();
  // }

  handleClick = () => {
    this.setState({
      background: !this.state.background
    });
  }

  centerAlign = () => {
    if (this.props.const_var.newDoorsArray.length > 0) {
      const activeWall = this.props.params.activeWall;

      let sortByPosX = (arr) => (arr.sort((a, b) => (a.positionX - b.positionX)));
      let filterRecord = sortByPosX(this.props.const_var.newDoorsArray.filter(data => data.userData.wallName === activeWall))

      if (filterRecord.length > 0) {
        let resultPosXArr = [];
        let resultPosYArr = [];
        let objIndex = 0;
        let preDoorWidth;

        let distanceBtw = 1;
        let wallWidth, wallHeight = 0;
        let initOffsetPosX = 0;




        if (activeWall === 'c_b_f_w' || activeWall === 'c_b_b_w' || activeWall === 'c_b_f_s_w' || activeWall === 'c_b_b_s_w') {
          wallWidth = this.props.params.p_w;
          wallHeight = this.props.params.p_h;
          initOffsetPosX = 0
        } else if (activeWall === 'c_b_r_s_f_w') {
          wallWidth = Number(this.props.params.cB_addStorage_right);
          wallHeight = this.props.params.p_h;
          initOffsetPosX = (this.props.params.p_w / 2) - (wallWidth / 2)
        } else if (activeWall === 'c_b_l_s_f_w') {
          wallWidth = Number(this.props.params.cB_addStorage_left);
          wallHeight = this.props.params.p_h;
          initOffsetPosX = (-this.props.params.p_w / 2) + (wallWidth / 2)          
        } else if (activeWall === 'c_b_l_w' || activeWall === 'c_b_r_w' || activeWall === 'c_b_l_s_r_w' || activeWall === 'c_b_r_s_l_w') {
          wallWidth = this.props.params.p_d;
          wallHeight = this.props.params.p_h;
          initOffsetPosX = 0
        } else if (activeWall === 'F_L_F_W') {
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentFront) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentFront) === 2) offsetLeanAlignment = -this.props.params.p_w / 2 + this.props.params.leanF_p_d / 2;
          else offsetLeanAlignment = this.props.params.p_w / 2 - this.props.params.leanF_p_d / 2;

          let offsetPosX = 0
          let addWidth = 0
          if (this.props.params.add_left_front_lean_porch && !this.props.params.add_right_front_lean_porch) {
            offsetPosX = this.props.params.lean_p_w / 2;
            addWidth = this.props.params.lean_p_w;
          } else if (!this.props.params.add_left_front_lean_porch && this.props.params.add_right_front_lean_porch) {
            offsetPosX = -this.props.params.leanR_p_w / 2;
            addWidth = this.props.params.leanR_p_w;
          } else if (this.props.params.add_left_front_lean_porch && this.props.params.add_right_front_lean_porch) {
            offsetPosX = this.props.params.lean_p_w / 2 - this.props.params.leanR_p_w / 2;
            addWidth = this.props.params.leanR_p_w + this.props.params.lean_p_w;
          } else {
            offsetPosX = 0;
            addWidth = 0;
          }
          wallWidth = this.props.params.leanF_p_d + addWidth;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = 0 + offsetLeanAlignment - offsetPosX;
        } else if (activeWall === 'F_L_R_W' || activeWall === 'F_L_R_S_W') {
          wallWidth = this.props.params.leanF_p_w;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = -(this.props.params.p_d / 2 + wallWidth / 2);
        } else if (activeWall === 'F_L_L_W') {
          wallWidth = this.props.params.leanF_p_w;
          wallHeight = this.props.params.leanF_p_h;
          initOffsetPosX = this.props.params.p_d / 2 + wallWidth / 2;
        } else if (activeWall === 'B_L_S_W') {
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentBack) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentBack) === 2) offsetLeanAlignment = -(this.props.params.p_w / 2 - this.props.params.leanB_p_d / 2);
          else offsetLeanAlignment = (this.props.params.p_w / 2 - this.props.params.leanB_p_d / 2);

          let offsetPosX = 0
          let addWidth = 0
          if (this.props.params.add_left_back_lean_porch && !this.props.params.add_right_back_lean_porch) {
            offsetPosX = -this.props.params.lean_p_w / 2;
            addWidth = this.props.params.lean_p_w;
          } else if (!this.props.params.add_left_back_lean_porch && this.props.params.add_right_back_lean_porch) {
            offsetPosX = this.props.params.leanR_p_w / 2;
            addWidth = this.props.params.leanR_p_w;
          } else if (this.props.params.add_left_back_lean_porch && this.props.params.add_right_back_lean_porch) {
            offsetPosX = this.props.params.leanR_p_w / 2 - this.props.params.lean_p_w / 2;
            addWidth = this.props.params.leanR_p_w + this.props.params.lean_p_w;
          } else {
            offsetPosX = 0;
            addWidth = 0;
          }
          wallWidth = this.props.params.leanB_p_d + addWidth;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = 0 + offsetLeanAlignment - offsetPosX;
        } else if (activeWall === 'B_L_B_W') {
          wallWidth = this.props.params.leanB_p_w;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = -(this.props.params.p_d / 2 + wallWidth / 2);
        } else if (activeWall === 'B_L_F_W' || activeWall === 'B_L_L_S_W') {
          wallWidth = this.props.params.leanB_p_w;
          wallHeight = this.props.params.leanB_p_h;
          initOffsetPosX = this.props.params.p_d / 2 + wallWidth / 2;
        } else if (activeWall === 'L_L_L_W') {
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentLeft) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentLeft) === 2) offsetLeanAlignment = this.props.params.p_d / 2 - this.props.params.lean_p_d / 2;
          else offsetLeanAlignment = -this.props.params.p_d / 2 + this.props.params.lean_p_d / 2;

          let offsetPosX = 0
          let addWidth = 0
          if (this.props.params.add_left_front_lean_porch && !this.props.params.add_left_back_lean_porch) {
            offsetPosX = -this.props.params.leanF_p_w / 2;
            addWidth = this.props.params.leanF_p_w;
          } else if (!this.props.params.add_left_front_lean_porch && this.props.params.add_left_back_lean_porch) {
            offsetPosX = this.props.params.leanB_p_w / 2;
            addWidth = this.props.params.leanB_p_w;
          } else if (this.props.params.add_left_front_lean_porch && this.props.params.add_left_back_lean_porch) {
            offsetPosX = this.props.params.leanF_p_w / 2 - this.props.params.leanB_p_w / 2;
            addWidth = this.props.params.leanF_p_w + this.props.params.leanB_p_w;
          } else {
            offsetPosX = 0;
            addWidth = 0;
          }
          wallWidth = this.props.params.lean_p_d + addWidth;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = 0 + offsetLeanAlignment - offsetPosX;
        } else if (activeWall === 'L_L_F_W' || activeWall === 'L_L_F_S_W') {
          wallWidth = this.props.params.lean_p_w;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = -(this.props.params.p_w / 2 + wallWidth / 2);
        } else if (activeWall === 'L_L_B_W') {
          wallWidth = this.props.params.lean_p_w;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = this.props.params.p_w / 2 + wallWidth / 2;
        } else if (activeWall === 'L_L_R_S_W') {
          wallWidth = this.props.params.add_storage;
          wallHeight = this.props.params.lean_p_h;
          initOffsetPosX = (this.props.params.p_d / 2 - this.props.params.add_storage / 2);
        } else if (activeWall === 'R_L_R_W') {
          let offsetLeanAlignment = 0;
          if (Number(this.props.params.leantoAlignmentRight) === 1) offsetLeanAlignment = 0;
          else if (Number(this.props.params.leantoAlignmentRight) === 2) offsetLeanAlignment = -this.props.params.p_d / 2 + this.props.params.leanR_p_d / 2;
          else offsetLeanAlignment = this.props.params.p_d / 2 - this.props.params.leanR_p_d / 2;

          let offsetPosX = 0
          let addWidth = 0
          if (this.props.params.add_right_front_lean_porch && !this.props.params.add_right_back_lean_porch) {
            offsetPosX = this.props.params.leanF_p_w / 2;
            addWidth = this.props.params.leanF_p_w;
          } else if (!this.props.params.add_right_front_lean_porch && this.props.params.add_right_back_lean_porch) {
            offsetPosX = -this.props.params.leanB_p_w / 2;
            addWidth = this.props.params.leanB_p_w;
          } else if (this.props.params.add_right_front_lean_porch && this.props.params.add_right_back_lean_porch) {
            offsetPosX = this.props.params.leanF_p_w / 2 - this.props.params.leanB_p_w / 2;
            addWidth = this.props.params.leanF_p_w + this.props.params.leanB_p_w;
          } else {
            offsetPosX = 0;
            addWidth = 0;
          }
          wallWidth = this.props.params.leanR_p_d + addWidth;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = 0 + offsetLeanAlignment - offsetPosX;
        } else if (activeWall === 'R_L_F_W' || activeWall === 'R_L_F_S_W') {
          wallWidth = this.props.params.leanR_p_w;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = this.props.params.p_w / 2 + wallWidth / 2;
        } else if (activeWall === 'R_L_B_W') {
          wallWidth = this.props.params.leanR_p_w;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = -(this.props.params.p_w / 2 + wallWidth / 2);
        } else if (activeWall === 'R_L_L_S_W') {
          wallWidth = this.props.params.add_storage_right;
          wallHeight = this.props.params.leanR_p_h;
          initOffsetPosX = -(this.props.params.p_d / 2 - this.props.params.add_storage_right / 2);
        }

        distanceBtw = (wallWidth - filterRecord.reduce((pre, nxt) => { return { width: pre.width + nxt.width } })["width"]) / (filterRecord.length + 1)

        for (var i = 0; i <= filterRecord.length - 1; i++) {
          let resultPosX = 0;
          let resultPosY = 0;
          let objSizeArr = typeof filterRecord[i].size == 'object' ? filterRecord[i].size.name.split("x"): filterRecord[i].size.split("x");
          let doorWidth = (filterRecord[i].userData.compType === "garage_door" || filterRecord[i].userData.compType === "garage_door_frameout") ? parseInt(objSizeArr[0]) : parseInt(objSizeArr[0]) / 12;
          let doorHeight = (filterRecord[i].userData.compType === "garage_door" || filterRecord[i].userData.compType === "garage_door_frameout") ? parseInt(objSizeArr[1]) : parseInt(objSizeArr[1]) / 12;

          if (distanceBtw >= 1) {
            // find position - X
            if (objIndex === 0) resultPosX = initOffsetPosX - wallWidth / 2 + distanceBtw + doorWidth / 2;
            else resultPosX = Number(resultPosXArr[objIndex - 1]) + preDoorWidth / 2 + distanceBtw + doorWidth / 2;

            // find position - Y
            if (resultPosX < filterRecord[i].minLimitX || resultPosX > filterRecord[i].maxLimitX) {
              resultPosY = wallHeight - doorHeight / 2;
            }
            else resultPosY = filterRecord[i].positionY;

            this.props.updateDoorWindowPosition(filterRecord[i].uniqueId, resultPosX, resultPosY);

            resultPosXArr[objIndex] = resultPosX;
            resultPosYArr[objIndex] = resultPosY;
            objIndex++;
            preDoorWidth = doorWidth;
          }
        }
      }

    }
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleTabClick);
 }

 componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleTabClick);
 }

 handleTabClick = () => {
    setTimeout(() => {
      if(controls.isCheckActiveTab == "doorwindow"){
        this.setState({tabName: controls.isCheckActiveTab})
      }else{
        if(controls.isCheckActiveTab != "doorwindow" && this.state.tabName != "other") this.setState({tabName: "other"})
      }
    },300)
 };

  render() {

    let isEditFullViewEnable = (this.props.const_var.ishideLeftNevigationBar!==undefined && this.props.const_var.ishideLeftNevigationBar=== true) ? true : false;
    let isClearComponentEnable = ((this.props.const_var.entry_points!==undefined && this.props.const_var.entry_points.length !== 0) || (this.props.const_var.cupolaEntries !== undefined && this.props.const_var.cupolaEntries.length !== 0) || this.props.const_var.newDoorsArray.length !== 0 || this.props.const_var.cupolas.length !== 0) ? true : false;

    let imageCount = 0;
    if (this.props.const_var.i_g_A_y.length > 0) {
        let checkImages = this.props.const_var.i_g_A_y.filter(data => data.image_name != "2D Layout1" && data.image_name != "2D Layout");
        imageCount = checkImages.length;
    }
    let mobile = window.innerWidth <= 1000
    //console.log(this.props.const_var.i_g_A_y,this.props.const_var.i_g_A_y.length,"this.props.const_var.i_g_A_y.length")
    return (
      <>
        <div className="building-controller">
          <div className='with-camera' data-tut={mobile == false ? "buildingcontrollerdesktop" : "buildingcontrollerdevice"}>
            <Dropdown className="controller-drpdwn" >
              <Dropdown.Menu renderOnMount={true}>
                <ul>
                  {isEditFullViewEnable == false && this.props.const_var.two_d_layuot != undefined &&
                      Object.keys(this.props.const_var.two_d_layuot).length > 0 &&
                        this.props.const_var.two_d_layuot.is_active == 1 &&
                          this.props.const_var.crmSetting.is_module_name!="inventory" 
                          ? 
                          <li className="draw ipad-show">
                            {/* <OverlayTrigger placement="top" className="controller-tooltip"
                              overlay={<Tooltip id={`tooltip-twodmap`}>2D Drawing</Tooltip>}
                            > */}
                                {(this.props.const_var.post_data!=undefined)
                                  ?                              
                                    <TwoDMapModal/>
                                  :
                                    null
                                  }
                            {/* </OverlayTrigger> */}
                          </li>
                        :
                      ''
                  }
                  {
                    isEditFullViewEnable == false &&
                    <li className="background-controller">
                      {/* <OverlayTrigger placement="top" className="controller-tooltip" overlay={<Tooltip id={`tooltip-twodmap`}>Background</Tooltip>}> */}
                        <a onClick={(e) => this.props.ChangeBackgroundAccordingtoCon()} className={this.props.const_var.crmSetting.is_show_background == true ? 'active-control' : ''}>
                          <span className="text">Background</span>
                          {((this.props.const_var.crmSetting.is_show_background != undefined && this.props.const_var.crmSetting.is_show_background == true)) ? <span className="icon icon-background-ico"></span> : <span className="icon icon-background-ico"></span>}
                        </a>
                      {/* </OverlayTrigger> */}
                    </li>
                  }
                  <li className="view-space-controller">
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ showViewInYourSpaceModal: true });
                      }}
                    >
                      <span className="text">View in your space</span>
                      <span className="icon icon-panel-view-ico"></span>
                    </a>
                  </li>
                  <li className="d-none">
                    <a onClick={e => { this.props.ChangeBackgroundAccordingtoCon(); }}  className={this.props.const_var.crmSetting.is_show_background == true ? 'active-control' : ''}>
                      <span className="text">Background</span>
                      {((this.props.const_var.crmSetting.is_show_background == true || this.props.const_var.crmSetting.is_show_background == undefined)) ? <span className="icon icon-background-ico"></span> : <span className="icon icon-eye-off"></span>}
                    </a>
                  </li>
                  <li className="zoom-in">
                    {/* <OverlayTrigger placement="top" className="controller-tooltip" overlay={<Tooltip id={`tooltip-twodmap`}>Zoom In/Out</Tooltip>}> */}
                      <div className='two-icon-group'>
                        <span className="text">Zoom In/Out</span>
                        <a onClick={e => this.zoomInOut(true)} className='left-icon'><span className="icon icon-zoom-in-ico"></span></a>
                        <a onClick={e => this.zoomInOut(false)} ><span class="icon icon-zoom-out-ico"></span></a>
                      </div>
                    {/* </OverlayTrigger> */}
                  </li>
                  {
                    isEditFullViewEnable == false &&
                    <>
                      <li className="measurement-controller">
                        {/* <OverlayTrigger placement="top" className="controller-tooltip"
                          overlay={
                            <Tooltip id={`tooltip-twodmap`}>Dimensions</Tooltip>
                          }
                        > */}
                          <a onClick={e => { this.props.ShowMeasure(); }} className={this.props.const_var.callMesure == true ? 'active-control' : ''}>
                            <span className="text">Dimensions</span>
                            <span className="icon icon-measurements-ico"></span>
                          </a>
                        {/* </OverlayTrigger> */}
                      </li>
                    </>
                  }
                  <li className={(this.state.tabName == "doorwindow") ? "d-none" : "frame-view-cntroler"}>
                    {/* <OverlayTrigger placement="top" className="controller-tooltip"
                      overlay={<Tooltip id={`tooltip-twodmap`}>{this.state.isfullviewbuilding ? 'Frame-only' : 'Frame-only'}</Tooltip>}
                    > */}
                      <a onClick={e => this.props.ShowHideTranslusant('full',controls.isCheckActiveTab)} className={this.props.params.is_translusant == true ? 'active-control' : ''}>
                        <span className="text">{this.props.isfullviewbuilding ? 'Frame-only' : 'Frame-only'}</span>
                        {this.props.isfullviewbuilding ?
                          <span className="icon icon-frame-ico"></span>
                          :
                          <span className="icon icon-frame-ico"></span>
                        }
                      </a>
                    {/* </OverlayTrigger> */}
                  </li>
                  <li className="inside-outside-controller d-none">
                    {/* <OverlayTrigger placement="top" className="controller-tooltip"
                      overlay={
                        <Tooltip id={`tooltip-twodmap`}>
                          {this.state.insideoutside ? 'OutSide' : 'Inside'}
                        </Tooltip>
                      }
                    > */}
                      <a onClick={e => this.navInOut()} className={this.state.insideoutside ? 'active-control' : ''}>
                        {this.state.insideoutside ? <span className="text">OutSide</span> : <span className="text">Inside</span>}
                        {this.state.insideoutside ? <span className="icon icon-outside-ico"></span> : <span className="icon icon-outside-ico"></span>}
                      </a>
                    {/* </OverlayTrigger> */}
                  </li>
                  {
                    (this.props.const_var.crmSetting.is_quote_Edit !=true && this.props.const_var.isPublicEdit !=true && isEditFullViewEnable == false) &&
                    <li className="full-view-cntroler">
                      {/* <OverlayTrigger
                        placement="top"
                        className="controller-tooltip"
                        overlay={
                          <Tooltip id={`tooltip-twodmap`}>
                            {this.state.isfullviewbuilding ? 'Panel View' : 'Full View'}
                          </Tooltip>
                        }
                      > */}
                        <a onClick={e => this.props.fullViewbuild()} className={this.props.isfullviewbuilding ? 'active-control' : ''}>
                          <span className="text">{this.props.isfullviewbuilding ? 'Panel View' : 'Full View'}</span>
                          {this.props.isfullviewbuilding ? <span className="icon icon-panel-view-ico"></span> : <span className="icon icon-panel-view-ico"></span>}
                        </a>
                      {/* </OverlayTrigger> */}
                    </li>
                  }
                  {
                    (this.props.const_var.crmSetting.is_quote_Edit !=true && this.props.const_var.isPublicEdit !=true && isClearComponentEnable == true) &&
                    <li className="clear-controller">
                      {/* <OverlayTrigger placement="top" className="controller-tooltip" overlay={<Tooltip id={`tooltip-twodmap`}>Clear Items</Tooltip>}> */}
                        <a onClick={(e) => this.props.clearComponents()}>
                          <span className="text">Clear Items</span>
                          <span className="icon icon-clear-ico"></span>
                        </a>
                      {/* </OverlayTrigger> */}
                    </li>
                  }
                  {this.props.const_var.loginSession == true ?
                  <li className="rotate-controller">
                      {/* <OverlayTrigger placement="top" className="controller-tooltip" overlay={<Tooltip id={`tooltip-twodmap`}>Reset</Tooltip>}> */}
                        <a  onClick={(e) => this.props.commonConfirmationAlert('cancel')}>
                          <span className="text">Reset</span>
                          <span className="icon icon-rotate--360"></span>
                        </a>
                      {/* </OverlayTrigger> */}
                    </li>
                  :null}
                  {this.props.params.ShowLeanRecord == true ?
                    <li className="show-center-building"><ShowFullBuilding /></li>
                    : null
                  }
                  <li className="show-center-building"><ShowFullBuilding /></li>
                </ul>
              </Dropdown.Menu>
            </Dropdown>
            {(this.props.const_var.loginSession == true) ?
              <div>
                <OverlayTrigger placement="top" className="controller-tooltip" overlay={<Tooltip id={`tooltip-twodmap`}>Photos</Tooltip>}>
                  <div className='photo-control' onClick={() => window.innerWidth > 992 ? this.props.handleShowPhotoModal() : this.props.getSelectedTab('capture')}>
                    <i className='icon-camra-ico' style={{color: this.props.isShowPhotoModal > 0 ? '#1FAC48' : ''}}></i>
                    {
                      imageCount > 0 &&
                      <span className='photocount photo-badge'>
                        {imageCount}
                      </span>
                    }
                  </div>
                </OverlayTrigger> 
              </div>
             :null}
          {(this.props.const_var.entry_points.length>0) ?
            <div className='info-content'>
                <OverlayTrigger placement="top" className="controller-tooltip" overlay={<Tooltip id={`tooltip-twodmap`}>Center Align</Tooltip>}>
                  <div className='center-btn' onClick={() => this.setAlignCenter()}>
                      <i className='icon-center-align-ico'></i>
                  </div>
                </OverlayTrigger> 
            </div>
          :null}
          <div className={this.props.discount_banner && this.props.const_var.crmSetting.companyType!=undefined && this.props.const_var.crmSetting.companyType!='manufacturer' && this.props.const_var.loginSession == true ? 'info-content mobile-bg-percent' : 'd-none info-content mobile-bg-percent' }> 
            <OverlayTrigger placement="top" className="controller-tooltip" overlay={<Tooltip id={`tooltip-twodmap`}>View All Discounts</Tooltip>}>
              <div className='center-btn' onClick={() => {window.open(this.props.const_var.crmSetting.web_url+'/manufacturer_active_discount', '_blank')}}>
                %
              </div>
              
            </OverlayTrigger> 
          </div>
        </div>

          <div className='extra-option-container d-none'>
            <div className='extra-option' style={{transform: this.state.isExtraHoverd ? 'rotate(45deg)': ''}} onClick={() => this.setState({isExtraHoverd: !this.state.isExtraHoverd})}>
              <i className={this.state.isExtraHoverd ? 'icon-cross-ico': 'icon-dots-ico'}></i>
            </div>
            {
              
              <div className='extra-option-tooltip' style={{opacity: this.state.isExtraHoverd ? 1: 0}}>
                {/* Removed code according to the requirement */}
                {/* <div className='extra-item'>
                  <i className='icon-screen-ico'></i>
                </div> */}
                <div
                  className='extra-item'
                  onClick={() => this.setState({ showViewInYourSpaceModal: true, isExtraHoverd: false })}
                >
                  <i className='icon-panel-view-ico'></i>
                </div>
                <div className='extra-item' onClick={() => this.props.handleShowShareModal()}>
                  <i className='icon-share-ico'></i>
                </div>
              </div>
            }
          </div>

          <ViewInYourSpaceModal
            show={this.state.showViewInYourSpaceModal}
            onHide={() => this.setState({ showViewInYourSpaceModal: false })}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {...state.reducer,...state.orderExtrasReducer}
}
const mapDispatchToProps = {
  updateDoorWindowPosition,
  removeComponent,
  ChangeBackgroundAccordingtoCon,
  handleCloseforDoorWindows,
  ShowMeasure,
  CallPublicAPI,
  captureBlobImages,
  handleShowExtras,
  commonConfirmationAlert,
  ShowHideTranslusant,
  handleShowfeedback,
  clearComponents,
  fullViewbuild,
  handleShowPhotoModal,
  handleShowShareModal,
  getSelectedTab
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BuildingController);
